import { IMucTriNang } from "../../model/respone/category/IMucTriNang";
import { apiClient } from "../apiClient";
export const MUC_TRI_NANG_ENDPOINT = "muc-tri-nang";
export const mucTriNangApi = {
  SelectAll: () => apiClient.get(`${MUC_TRI_NANG_ENDPOINT}`),
  Insert: (payload: IMucTriNang) =>
    apiClient.post(`${MUC_TRI_NANG_ENDPOINT}`, payload),
  Update: (payload: IMucTriNang) =>
    apiClient.put(`${MUC_TRI_NANG_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${MUC_TRI_NANG_ENDPOINT}/${id}`),
};
